import { createSelector } from '@ngrx/store';

import {
  selectElectricityDynamicPricesAvailabilityVM,
  selectIsDynamicPricesAvailabilityError,
  selectIsDynamicPricesAvailabilitySuccess,
} from './dynamic-prices-availability.selectors';
import type { DynamicPricesModel, SelectedHourInfo } from '../models';
import {
  selectGetDynamicPricesPayload,
  selectIsDynamicPricesError,
  selectIsDynamicPricesLoading,
  selectIsNewDynamicPricesEntitySuccess,
  selectSelectedDynamicPricesActionId,
  selectSelectedDynamicPricesEntry,
  selectSelectedEnergyType,
  selectSelectedHour,
} from './dynamic-prices.selectors';

export const selectSelectedHourInfo = createSelector(
  selectSelectedHour,
  selectSelectedDynamicPricesEntry,
  selectSelectedEnergyType,
  (hour, entry, selectedEnergyType): SelectedHourInfo => ({
    selectedHour: hour,
    selectedTariff: entry?.tariffs[hour],
    unitOfMeasurement: entry?.unitOfMeasurement,
    minTariff: entry?.minAmount,
    maxTariff: entry?.maxAmount,
    selectedEnergyType,
  })
);

export const selectIsInitialLoadSuccessfull = createSelector(
  selectIsNewDynamicPricesEntitySuccess,
  selectIsDynamicPricesAvailabilitySuccess,
  (pricesSuccess, availabilitySuccess) => pricesSuccess && availabilitySuccess
);

export const selectDynamicPricesVM = createSelector(
  selectSelectedDynamicPricesEntry,
  selectGetDynamicPricesPayload,
  selectElectricityDynamicPricesAvailabilityVM,
  selectIsDynamicPricesLoading,
  selectSelectedDynamicPricesActionId,
  selectIsDynamicPricesError,
  selectIsDynamicPricesAvailabilityError,
  (
    entity,
    currentPayload,
    availability,
    isLoading,
    lastLoadedDate,
    isDateError,
    isAvailabilityError
  ): DynamicPricesModel => ({
    entity,
    currentPayload,
    availability,
    isLoading,
    lastLoadedDate,
    isDateError,
    isAvailabilityError,
  })
);
